import React, { useEffect } from 'react'
import ParticipantView from '../../components/views/ParticipantView';
import { dashboardActions } from '../../redux-utils/actions/dashboard-actions';
import { connect, useSelector} from 'react-redux';
import Loader from '../../components/Loader';
import { useAuth } from '../../custom-hooks/useAuth';
import OpenedSidebar from '../../components/openedSidebar';
import ClosedSidebar from '../../components/closedSidebar';

const { allParticipantAction, singleParticipantAction } = dashboardActions;

function ParticipantData(props) {
  const {
    allParticipantResult
  } = props;
  const { allParticipantData } = allParticipantResult;
  const isOpened = useSelector((state) => state.sidebarState.isOpen);

  if(allParticipantResult.allParticipantData && allParticipantResult.allParticipantData.length > 0) {
    return(
      <ParticipantView allParticipantData={allParticipantData} allParticipantResult={allParticipantResult} />
    )
  }

  return (
    (allParticipantResult.status === "" || allParticipantResult.status === "all_participant_fetch_start") ? (
      <div className="bg-[#F9F9F9] font-sans flex">
         {isOpened ?  <OpenedSidebar /> : <ClosedSidebar/>}
        <Loader />
      </div>
    ) :
    (
      <ParticipantView allParticipantData={allParticipantData} allParticipantResult={allParticipantResult} />
    )
  ) 
}

const areEqual = (prevProps, nextProps) => {
  // Check if the data prop is equal
  return prevProps.allParticipantResult.allParticipantData === nextProps.allParticipantResult.allParticipantData
};
const ParticipantMemo = React.memo(ParticipantData, areEqual)

function Participants(props) {

  const { 
    allParticipantDispatchAction,
    singleParticipantDispatchAction,
    allParticipantResult
  } = props;

  const { getLogin } = useAuth();
  const loginStorage = JSON.parse(getLogin());

  useEffect(() => {
    const allParam = {
      token: loginStorage && loginStorage.loginData.data.token
    }
    allParticipantDispatchAction(allParam);

  }, [])

  return (
    <>
      <ParticipantMemo 
        allParticipantDispatchAction={allParticipantDispatchAction} 
        singleParticipantDispatchAction={singleParticipantDispatchAction}
        allParticipantResult={allParticipantResult}
      />
    </>
  )
}

const mapStateToProps = state => ({
  allParticipantResult: state.dashboardState,
})

const mapDispatchToProps = dispatch => ({
  allParticipantDispatchAction: (param) => dispatch(allParticipantAction(param)),
  singleParticipantDispatchAction: (param) => dispatch(singleParticipantAction(param))
})

export default connect(mapStateToProps, mapDispatchToProps)(Participants)